angular.module('zc.core')
  .component('zcSessionPriceDistribution', {
    templateUrl: '/templates/core/components/session_price_distribution/session_price_distribution.html',
    bindings: {
      project: '<',
      campaign: '<',
      sessions: '<',
      disabled: '<',
      field: '@'
    },
    controller: sessionPriceDistributionController,
  });

sessionPriceDistributionController.$inject = ['$rootScope', '$scope', '$timeout', '$translate', 'ChartV2', 'columnChartV2Config', 'currencies'];
function sessionPriceDistributionController($rootScope, $scope, $timeout, $translate, ChartV2, columnChartV2Config, currencies) {
  const vm = this;

  const RANDOM_DIGIT = 10;
  const MIN = 0;
  const STEP = 1000;
  const NORMAL_RANGE = 0.95;
  const PLOT_BANDS_COLOR = 'rgba(68, 170, 213, .2)';

  let ranges = [];
  let deregisterStateChangeStart = null;

  const chart = new ChartV2(columnChartV2Config, {
    xAxis: {
      categories: getCategories(),
      labels: { enabled: false },
      tickLength: 0,
      tickWidth: 0,
      crosshair: true
    },
    yAxis: {
      min: 0,
      labels: { enabled: false }
    },
    options: {
      plotOptions: {
        column: {
          stacking: 'normal'
        }
      },
      tooltip: {
        valueSuffix: ' %',
        valueDecimals: 1,
        shared: true
      },
    }
  });

  vm.$onInit = () => {
    vm.currency = currencies[vm.project.currency];
    vm.chartConfig = chart.getConfig();
    vm.sliderConfig = {
      disabled: vm.disabled,
      floor: MIN,
      step: STEP,
      translate: function(value) {
        return `${vm.currency.symbol}${value}${vm.currency.suffix}`;
      }
    };
    vm.modalId = `modal-${Math.floor(Math.random() * RANDOM_DIGIT)}`;
    vm.resizeFull = resizeFull;
    vm.resizeSmall = resizeSmall;
    $scope.$watch('$ctrl.sessions', addSeries);
    $scope.$watchGroup(['$ctrl.campaign.price_max_threshold', '$ctrl.campaign.price_min_threshold'], plotBands);
    deregisterStateChangeStart = $rootScope.$on('$stateChangeSuccess', fixResizeProblem);
  };

  vm.$onDestroy = () => {
    deregisterStateChangeStart();
  };

  function addSeries(sessions) {
    const totalSessionCount = sessions.length;
    const prices = getPrices(sessions);
    const max = _.max(prices);
    ranges = _.range(MIN, max, STEP);
    vm.chartConfig.xAxis.categories = getCategories();
    chart.resetSeries();
    chart.addSeries({
      name: $translate.instant('sharedModules.core.components.sessionPriceDistribution.wariai'),
      data: getDistributions(prices, totalSessionCount)
    });
    $timeout(() => {
      vm.sliderConfig.ceil = _.last(ranges);
      plotBands([vm.campaign.price_max_threshold, vm.campaign.price_min_threshold]);
    }, 0);
  }

  function getPrices(conversions) {
    const prices = _.chain(conversions).map(vm.field).compact().sortBy().value();
    return prices.slice(0, prices.length * NORMAL_RANGE);
  }

  function getCategories() {
    return _.map(ranges, range => `${vm.currency.symbol}${range}-${range + STEP}${vm.currency.suffix}`);
  }

  function getDistributions(prices, totalConversionCount) {
    const countByMin = _.countBy(prices, price => Math.floor(price / 1000) * 1000);
    return _.map(ranges, range => {
      const count = countByMin[range] || 0;
      return count / totalConversionCount * 100;
    });
  }

  function plotBands([min, max]) {
    vm.chartConfig.xAxis.plotBands = [{
      from: _.indexOf(ranges, min),
      to: _.indexOf(ranges, max),
      color: PLOT_BANDS_COLOR
    }];
  }

  function resizeFull() {
    const $modal = $(`#${vm.modalId}`);
    $modal.modal('show');
    // NOTE:
    // Need to call fixResizeProblem once modal has been shown.
    // It does not work before the modal is completely shown.
    $modal.on('shown.bs.modal', () => {
      fixResizeProblem();
    });
  }

  function resizeSmall() {
    const $modal = $(`#${vm.modalId}`);
    $modal.modal('hide');
  }

  function fixResizeProblem() {
    // NOTE:
    // There is a bug that Highcharts is not sizing correctly
    // when dynamically changing the screen size until calling reflow.
    // See https://github.com/pablojim/highcharts-ng/issues/550
    $scope.$broadcast('highchartsng.reflow');
    // NOTE:
    // There is a bug that Angularjs-Slider is not sizing correctly when dynamically changing the screen
    // (OMG, don't give me the same SPA shit in a one day...).
    // Calling the rzSliderForceRender event solves the problem.
    // See https://github.com/angular-slider/angularjs-slider/issues/79
    $scope.$broadcast('rzSliderForceRender');
  }
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/components/session_price_distribution/session_price_distribution.js